// extracted by mini-css-extract-plugin
export default {"wrapper":"BlockAnchor_wrapper__iqyxs","copyButton":"BlockAnchor_copyButton__zBSKy","icon":"BlockAnchor_icon__fwL9j","copiedText":"BlockAnchor_copiedText__3f0vc"};